import { render, staticRenderFns } from "./BasMaterialModal.vue?vue&type=template&id=0d40c81c&scoped=true&"
import script from "./BasMaterialModal.vue?vue&type=script&lang=js&"
export * from "./BasMaterialModal.vue?vue&type=script&lang=js&"
import style0 from "./BasMaterialModal.vue?vue&type=style&index=0&id=0d40c81c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d40c81c",
  null
  
)

export default component.exports